module.exports = __webpack_public_path__ + "static/img/home_bg.34992a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_bg.jpg
// module id = lJjX
// module chunks = 1